<div
  class="week-picker-list"
  [class.with-years]="showYears"
  [class.without-years]="!showYears"
>
  <div
    class="week-selector"
    [class.with-years]="showYears"
    [class.without-years]="!showYears"
    #weekSelector
  >
    @for (w of weeks; track w) {
      <div
        class="ag-list-item"
        [class.is-selected]="week === w"
        (click)="setWeek($event, w)"
      >
        {{ w }}
      </div>
    }
  </div>
  <div class="year-selector" [class.hide-element]="!showYears" #yearSelector>
    @for (y of years; track y) {
      <div
        class="ag-list-item"
        [class.is-selected]="year === y"
        (click)="setYear($event, y)"
      >
        {{ y }}
      </div>
    }
  </div>
  <p-button
    label="Done"
    severity="info"
    styleClass="h-full w-[4rem] !rounded-none"
    (onClick)="done.emit()"
  />
</div>
